<div class="pagination-container">
  @if (!isResourceInDropdownSettings()) {
    <div class="pagination-go-page">
      Перейти на страницу: {{ firstPage }} - {{ tableData.totalPages }}
      <input
        class="pagination-input"
        type="number"
        placeholder="1"
        [(ngModel)]="selectTablePage"
        (keyup.enter)="goToPage(selectTablePage)"
        (keydown)="preventInvalidNumericInput($event)"
        (input)="preventDecimalInput($event)"
      >
    </div>
  }
  <mat-paginator
    showFirstLastButtons
    [pageSize]="pageSize"
    [pageIndex]="tableData.number"
    [length]="tableData.totalElements"
    [pageSizeOptions]="pageSizeOptions"
    (page)="changePageParams($event)"
  ></mat-paginator>
</div>
